module.exports = __webpack_public_path__ + "images/help/icon-twr46@2x-67cdaa8dd54d6ee81c1e203d349fbfab.png";